export const SET_ACTIVE_DATE = 'CS/SET_ACTIVE_DATE';
export const REPORT_OVERVIEW_VIEW_EVENT = 'CS/REPORT_OVERVIEW_VIEW_EVENT';
export const REPORT_OVERVIEW_SEE_DETAILS_CLICK_EVENT = 'CS/REPORT_OVERVIEW_SEE_DETAILS_CLICK';
export const REPORT_INFORMATION_BACK_CLICK_EVENT = 'CS/REPORT_INFORMATION_BACK_CLICK';
export const UPDATE_VIEW_STATE = 'CS/UPDATE_TIME_MACHINE_VIEW_STATE';
